const mod = crateImports["zustand"];
const { create,createStore,useStore } = mod;
export { create,createStore,useStore };
export default mod.default ?? mod;